import { useState } from 'react';
import { Box, TextField, Button, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import { getDevicesByPlace, resetDeviceData, updateStatusFilter } from '../../redux/slices/devices';
import { RootState } from '../../redux/store';
import { CleanFilterButton } from '../library/CompactClearFilterButton';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1.5),
    minWidth: 120,
  },
  searchButton: {
    height: '100%',
  },
}));

export function DevicesFormFilter() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { deviceRef: currentDeviceRef, statusFilter } = useSelector((state: RootState) => state.devices);
  const [searchTerm, setSearchTerm] = useState(currentDeviceRef || '');
  const [status, setStatus] = useState(statusFilter || 'Todos');

  const handleSearch = () => {
    if (!searchTerm.trim()) return;

    setStatus('Todos');
    dispatch(resetDeviceData());
    dispatch(
      getDevicesByPlace({
        _end: 10,
        _order: 'DESC',
        _sort: 'createdAt',
        _start: 0,
        deviceRef: searchTerm.trim(),
      })
    );
  };

  const handleStatusChange = (newStatus: string) => {
    setStatus(newStatus);
    setSearchTerm('');

    const isOnline = newStatus === 'Online' ? true : newStatus === 'Offline' ? false : undefined;
    dispatch(updateStatusFilter(newStatus, isOnline));
  };

  const handleClear = () => {
    setStatus('Todos');
    setSearchTerm('');
    dispatch(updateStatusFilter('Todos', undefined));
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ml: -1 }}>
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="devices-status">Status</InputLabel>
        <Select
          labelId="status-label"
          id="status"
          name="status"
          value={status}
          onChange={(e) => handleStatusChange(e.target.value as string)}
          label="Status"
        >
          <MenuItem value="Todos">Todos</MenuItem>
          <MenuItem value="Online">Online</MenuItem>
          <MenuItem value="Offline">Offline</MenuItem>
        </Select>
      </FormControl>
      <CleanFilterButton onClick={handleClear} />
      <TextField
        className={classes.formControl}
        label="Buscar dispositivo"
        variant="outlined"
        size="small"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch();
          }
        }}
      />
      <Button
        variant="contained"
        className={classes.searchButton}
        onClick={handleSearch}
        startIcon={<Icon icon={searchFill} />}
        sx={{
          marginRight: 2.5,
        }}
      >
        Buscar
      </Button>
    </Box>
  );
}
